var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFriendList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.983 101.187L80.9834 81.1875",
    stroke: "url(#paint0_linear_488_9576)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9834 91.1875C75.3134 91.1875 90.9834 75.5175 90.9834 56.1875C90.9834 36.8575 75.3134 21.1875 55.9834 21.1875C36.6534 21.1875 20.9834 36.8575 20.9834 56.1875C20.9834 75.5175 36.6534 91.1875 55.9834 91.1875Z",
    stroke: "url(#paint1_linear_488_9576)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_488_9576",
    x1: 79.5146,
    y1: 81.1875,
    x2: 100.983,
    y2: 101.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_488_9576",
    x1: 15.8424,
    y1: 21.1875,
    x2: 90.9834,
    y2: 91.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFriendList);
export default __webpack_public_path__ + "static/media/no_friend_list.df1d0e55b79ebd4120fc342175df0a9f.svg";
export { ForwardRef as ReactComponent };